<template>
  <div>
    <div class="grey lighten-5 cbg-white-container">
      <v-row class="m-0">
        <v-col cols sm="6" md="4">
          <label for class="fz-10px">Search by Executive name / Referral code</label>
          <div class="search-div position-relative">
            <input
              class="form-control"
              label="Search by Name"
              placeholder="Name"
              v-model="search"
              @input="debounceSearch()"
            />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </v-col>
        <v-col cols sm="6" md="3" class="datepicker pos-r">
          <label for class="d-block-mob">Date Range</label>
          <datepicker
            v-model="dateRange"
            @input="dateChange()"
            ref="datepicker"
            :model-config="datePickerConfig"
            :max-date="new Date()"
            is-range
            :masks="{ input: 'DD/MM/YYYY' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control position-relative"
                placeholder="DD/MM/YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetActiveDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </v-col>
        <v-col cols sm="6" md="2">
          <div class="position-relative">
            <label for>Profile</label>
            <select name id class="form-control" @change="changeProfile()" v-model="isCompleted">
              <option value>All</option>
              <option :value="true">Completed</option>
              <option :value="false">Not Completed</option>
            </select>

            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </v-col>
        <v-col cols sm="6" md="1">
          <div class="position-relative">
            <label for>Role</label>
            <select name id class="form-control" @change="changeRole()" v-model="role">
              <option value>All</option>
              <option value="doctor">Doctor</option>
              <option value="pharmacy">Pharmacy</option>
              <option value="ambulance">Ambulance</option>
              <option value="diagnostics-lab">Diagnostics</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </v-col>
        <v-col v-if="permissions.includes('EXPORT_REFERRED_MARKETING_USERS_LIST')" class="col-1">
          <label class="col-sm-12 mb-0 d-none-mob1"></label>
          <v-btn
            class="btn btn-primary"
            @click="getReferredUsersListAsCsv"
            :disabled="isEmpty"
          >export</v-btn>
        </v-col>
      </v-row>

      <loader v-if="showLoader"></loader>
      <v-col cols="12" class="mt-2">
        <div class="table-div overflow-auto">
          <table class="table userlistTable small-table-width">
            <thead>
              <tr class="table-success">
                <th scope="col">Date of joining</th>
                <th scope="col">Ref code no</th>
                <th scope="col">Company Name</th>
                <th scope="col">Executive Name</th>
                <th scope="col">Referred User</th>
                <th scope="col">Role</th>
                <th scope="col">Contact Number</th>
                <th scope="col">Location</th>
                <th scope="col">Subscription</th>
              </tr>
            </thead>
            <tbody v-if="!isEmpty">
              <tr v-for="(list, i) in referralUserList" :key="i">
                <td>
                  <div>
                    {{
                    dayJS(list.date_of_joining).format(formats.date_format)
                    }}
                  </div>
                </td>
                <td>
                  <div>{{ list.referral_code_used }}</div>
                </td>
                <td>
                  <div>{{ list.company_name }}</div>
                </td>
                <td>
                  <div>{{ list.executive_name }}</div>
                </td>
                <td>
                  <div>{{ list.user_name }}</div>
                </td>
                <td>
                  <div>{{ list.completed_profiles ? list.completed_profiles[0] : "&#8213;" }}</div>
                </td>
                <td>
                  <div>{{ list.contact }}</div>
                </td>
                <td>
                  <div>
                    {{
                    list && list.location && list.location.current_address
                    ? `${list.location.current_address.city}, ${list.location.current_address.country}`
                    : "&#8213;"
                    }}
                  </div>
                </td>
                <td>
                  <div>N/A</div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
            <tbody v-if="isEmpty">
              <tr>
                <td colspan="12">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <pagination
        class="mx-3 pagination-block"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
        v-if="!isEmpty"
      />
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
const pagination = () => import("@/views/common/Pagination");
import formats from "@/formats";
const loader = () => import("@/components/loader.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
export default {
  components: {
    loader,
    Datepicker,
    pagination,
    ...pickSvg("crossSVG ")
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      dayJS,
      formats,
      search: "",
      showLoader: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 0,
      dateRange: {
        start: "",
        end: ""
      },
      referralUserList: [],
      isEmpty: false,
      isCompleted: "",
      role: "",
      total: 0
    };
  },
  mounted() {
    this.getReferredUsersList();
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.getReferredUsersList();
    },
    //  profile change event call
    changeProfile() {
      this.getReferredUsersList();
    },

    //  role change event call
    changeRole() {
      this.getReferredUsersList();
    },

    //  page change event call
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getReferredUsersList();
    },

    //  date change event call
    dateChange() {
      this.getReferredUsersList();
    },

    //  search filter event call
    debounceSearch: debounce(function() {
      this.getReferredUsersList();
    }, 500),

    // getReferredUsersList api call
    getReferredUsersList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        start_date: this.dateRange.start.toString(),
        end_date: this.dateRange.end.toString(),
        search_text: this.search,
        profile_is_completed: this.isCompleted,
        role_filter: this.role
      };
      let url = `${config.BASE_URL}api/v2/admin/referred-users`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.referralUserList = response.body.data.list;
            this.referralUserList = this.referralUserList.map(user => {
              if (user.roles.length > 1) {
                user.roles = user.roles.filter(el => el !== "patient");
              }
              return user;
            });
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.referralUserList = [];
            this.isEmpty = true;
          }
        }
      });
    },

    // getReferredUsersListAsCsv api call
    getReferredUsersListAsCsv() {
      this.showLoader = true;
      let params = {
        start_date: this.dateRange.start.toString(),
        end_date: this.dateRange.end.toString(),
        search_text: this.search,
        profile_is_completed: this.isCompleted,
        role_filter: this.role
      };
      let url = `${config.BASE_URL}api/v2/admin/referred-users-csv`;
      this.$http.get(url, { params }).then(response => {
        this.showLoader = false;
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(
          new Blob(["\ufeff", response.body])
        );
        downloadLink.download = "export_referred_users.csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    }
  }
};
</script>
<style lang="scss">
.table th,
.table td {
  vertical-align: middle;
}
</style>